<template>
    <div class="Column spackage padding-20 bgc box-shadow">
        <div>
            <el-button type="primary" @click="addColumn">新增栏目页</el-button>
            <span style="margin-left: 20px">最多增加5个栏目</span>
        </div>
        <el-table :data="tableData" style="margin-top: 30px">
            <el-table-column label="序号" align="left" type="index"></el-table-column>
            <el-table-column prop="columnname" label="栏目名称" align="center"></el-table-column>
            <el-table-column prop="linktypename" label="栏目类型" align="center"></el-table-column>
            <el-table-column prop="linkurl" label="链接内容" align="center" width="260"></el-table-column>
            <el-table-column label="状态" align="center" width="100">
                <template slot-scope="scope">
                    <p style="color: #fa5555" v-if="scope.row.status === 0">失效</p>
                    <p style="color: #409EFF" v-if="scope.row.status === 1">正常</p>
                </template>
            </el-table-column>
            <el-table-column prop="subjectcount" label="帖子总数" align="center" width="95"></el-table-column>
            <el-table-column prop="subjecttopcount" label="精华总数" align="center" width="95"></el-table-column>
            <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                    <div class="table-position" v-if="scope.row.status === 1">
                        <p @click="update(scope.row.innerid)">编辑</p>
                        <!--@click="scope.row.innerid"-->
                        <span>|</span>
                        <p @click="paixu(scope.row.innerid)">排序</p>
                        <span>|</span>
                        <p @click="delcolumn(scope.row.innerid)">删除<p/>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            title="添加栏目"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="cancel">

            <el-form ref="form" class="dataform" :model="form" :rules="rules">

                <el-form-item label="栏目类型" prop="linktype">
                    <el-select v-model="form.linktype" placeolder="选择栏目标签" @change="clearTab" style="width: 260px">
                        <el-option v-for="item in linktypeList" :key="item.type" :label="item.name" :value="item.type"></el-option>
                    </el-select>
                </el-form-item>


                <div class="block" v-if="form.linktype === 2">
                    <el-form-item label="商品类型" prop="kmctype">
                        <el-select v-model="form.kmctype" style="width: 260px">
                            <el-option v-for="item in activeList" :key="item.name" :label="item.label" :value="item.name"></el-option>
                        </el-select>
                        <p>展示此类商品的列表</p>
                    </el-form-item>
                </div>
                <!-- end 知识商品 -->

                <el-form-item v-if="form.linktype === 3">
                    <div class="block">
                        <el-button type="primary" @click="addGoodsBtn">选择商品</el-button>
                        <div class="card tw" v-if="shopDetails !== ''">
                            <div class="img">
                                <!-- <img :src="shopDetails.logoPic.furl" alt="pic"> -->
                                <p class="tag">{{shopDetails.kmctypeText}}</p>
                            </div>
                            <p class="title">{{shopDetails.kmcname}}</p>
                            <i class="el-icon-error" @click="shopDetails = ''"></i>
                        </div>
                        <p>展示此商品的详情页</p>
                    </div>
                </el-form-item>
                <!-- end 单一商品 -->

                <el-form-item v-if="form.linktype === 4">
                    <div class="block">
                        <el-button type="primary" @click="openShopDialog">选择商品分组</el-button>
                        <div class="card fz" v-if="setCommoditydata !== ''">
                            <p class="title">{{setCommoditydata.name}}</p>
                            <i class="el-icon-error" @click="setCommoditydata = ''"></i>
                        </div>
                        <p>展示此类商品分组的列表</p>
                    </div>
                </el-form-item>
                <!-- end 商品分组 -->

                <el-form-item v-if="form.linktype === 99">
                    <div class="block">
                        <div class="card">
                            <el-input v-model="form.linkurl" placeholder="输入链接地址"></el-input>
                        </div>
                        <p>展示该链接的网页</p>
                    </div>
                </el-form-item>
                <!-- end 自定义链接 -->

                <el-form-item label="栏目名称" prop="columnname">
                    <el-input v-model="form.columnname" placeholder="输入栏目名称（最多五个字）" maxlength="5" show-word-limit style="width: 260px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

        <commodity ref="commodity" @setCommodity="setCommodity"></commodity>
        <shopGroup ref="shopGroup" @setShopGroup="setShopGroupList"></shopGroup>

    </div>
</template>

<script>
    import {findGoodsGroupInfo, removeGroup, goodsSort, getAssetGroupInfo} from 'api/materialMgtApi'
    import {getProductDetail} from 'api/shop'
    import { deleteCwKmcStarcustomcolumninfo, getCwKmcStarcustomcolumninfoList, saveCwKmcStarcustomcolumninfo, updateCwKmcStarcustomcolumninfoIndex, getCwKmcStarcustomcolumninfodetail} from 'api/communityApi'
    import Commodity from 'views/shopMgt/mob/page/dataComponents/commodity'
    import ShopGroup from 'views/shopMgt/mob/page/dataComponents/shopGroup'
    // import AddGoodsTips from 'views/shopMgt/goods/goodsTips/AddGoodsTips'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "column",
        data() {
            return {
                innerid: this.$route.query.innerid,
                columninnerid: '',
                form: {
                    linktype: '', // 栏目类型
                    linkurl: '', // 链接地址
                    kmctype: '',  //  商品类型
                    columnname: '', // 栏目名称
                    linkkeyid: '',//单一商品放商品innerid；分组放组id
                    linkname: ''   // 如果是商品，就传商品名称，如果是组，就传组名称
                }, // 表单数据
                goodsListData: [],
                rules: {
                    linktype: [{required: true, message: '请选择栏目类型', trigger: 'blur'}],
                    kmctype: [{required: true, message: '请选择商品类型', trigger: 'blur'}],
                    columnname: [{required: true, message: '请输入栏目名称', trigger: 'blur'}]
                },
                activeList: [{label: '图文', name: 1}, {label: '报告', name: 2}, {label: '视频', name: 4}, {label: '专题', name: 5}],
                dialogVisible: false,   // 表单显示
                linktypeList: [{type:1,name:'论坛型'},{type:2,name:'商品单类'},{type:3,name:'商品单品'},
                    {type:4,name:'商品分组'},{type:99,name:'自定义链接'}],//  栏目类型
                shopDetails: '', // 单一商品,
                setCommoditydata: '',  // 商品分组
                tableData: [],   // 栏目列表
                updatestart: false,    // 修改状态
            }
        },
        methods: {
            getCwKmcStarcustomcolumninfodetailList(innerid,types) {

                if (types === 'update') {
                    this.updatestart = true
                    console.log('修改')
                } else {
                    this.updatestart = false
                    console.log('新增')
                }
                this.setLoading(true)
                getCwKmcStarcustomcolumninfodetail({
                    data: {innerid:innerid},
                    success: data => {
                        
                        let tdata = data.data

                        this.columninnerid = innerid

                        this.dialogVisible = true
                        this.form.linktype = tdata.linktype
                        this.form.linkurl = tdata.linkurl

                        if (tdata.kmctype !== 0) {
                            this.form.kmctype = tdata.kmctype
                        }
                        
                        this.form.columnname = tdata.columnname
                        
                        if (tdata.linktype === 4) {
                            this.setCommoditydata = {
                                name: tdata.linkname
                            }
                        } else if (tdata.linktype === 3) {
                            this.shopDetails = {
                                kmctypeText: tdata.kmctypename,
                                kmcname: tdata.linkname
                            }
                        }

                        console.log(data)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }

                })
            },
            openShopDialog() {
                // 商品分组
                this.$refs.shopGroup.openDialog([])
            },
            addGoodsBtn() {
                // 选择商品
                this.$refs.commodity.openDialog()
            },
            tableList() {
                this.setLoading(true)
                getCwKmcStarcustomcolumninfoList({
                    data: {starid: this.innerid, page:1, pageSize:5},
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            initAadd() {
                this.form = {
                    linktype: '', // 栏目类型
                    linkurl: '', // 链接地址
                    kmctype: '',  //  商品类型
                    columnname: '', // 栏目名称
                    linkkeyid: '',//单一商品放商品innerid；分组放组id
                    linkname: '',   // 如果是商品，就传商品名称，如果是组，就传组名称
                    innerid: ''
                }

                this.shopDetails = this.setCommoditydata = '' // 单一商品
            },
            addColumn() {
                // 判断栏目页是否超过 5 个
                let tabledatalist = this.tableData,
                    num = 0
                for (let item in tabledatalist) {
                    if (tabledatalist[item].status === 1) {
                        num ++
                    }
                }

                if (num === 5 || num > 5) {
                    this.$message.error('最多增加5个栏目')
                } else {
                    // 数据初始化
                    this.initAadd()
                    this.dialogVisible = true
                    this.updatestart = false
                }

            },
            setShopGroupList(row) {
                let $this = this
                // 商品分组
                this.$nextTick(() => {
                    // console.log(row)
                    $this.setCommoditydata = row
                    $this.form.linkkeyid = row.innerid
                    $this.form.linkname = row.name
                })
            },
            setCommodity(shop) {
                let $this = this
                // 单一商品
                this.$nextTick(() => {
                    $this.shopDetails = shop
                    $this.form.linkkeyid = shop.kmcinnerid
                    $this.form.kmctype = shop.kmctype
                    $this.form.linkname = shop.kmcname
                })
            },
            cancel() {
                this.$nextTick(() => {
                    this.dialogVisible = false
                    this.form  = {
                        linktype: '', // 栏目类型
                        linkurl: '', // 链接地址
                        kmctype: '',  // 商品类型
                        columnname: '', // 栏目名称
                        linkkeyid: '',//单一商品放商品innerid；分组放组id
                    }   // 表单数据
                })
            },
            clearTab() {
                // console.log('清空')
                // this.$nextTick(() => {
                //     this.form.linkurl = this.form.columnname =  this.form.linkkeyid = this.form.kmctype = ''   // 表单数据
                // })
            },
            submit() {
                let form = this.form;
                if (form.linktype === '') {
                    this.$message.error('栏目类型不能为空！')
                } else if (form.columnname === '') {
                    this.$message.error('栏目名称不能为空！')
                } else {
                    switch (this.linktype) {
                        case 2:
                            if (form.kmctype === '') {
                                this.$message.error('商品类型不能为空！')
                                return
                            }
                            break;
                        case 3:
                            if (form.linkkeyid === '') {
                                this.$message.error('请选择商品！')
                                return
                            }
                            break;
                        case 4:
                            if (form.linkkeyid === '') {
                                this.$message.error('请选择商品分组！')
                                return
                            }
                            break;
                        case 99:
                            if (form.linkurl === '') {
                                this.$message.error('链接地址不能为空！')
                                return
                            }
                            break;
                    }

                    let data = JSON.parse(JSON.stringify(this.form))
                    data.starid = this.innerid

                    if (this.updatestart === true) {
                        // 修改栏目状态下
                        console.log('修改',this.columninnerid)
                        data.innerid = this.columninnerid
                    }

                    this.setLoading(true)
                    saveCwKmcStarcustomcolumninfo({
                        data: data,
                        success:data => {
                            this.setLoading(false)
                            this.$message.success('保存栏目成功')
                            this.tableList()
                            this.cancel()
                            // 重置状态
                            this.updatestart = false
                        },
                        error:data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                            // 重置状态
                            this.updatestart = false
                        }
                    })
                    console.log(this.form)
                }
            },
            update(innerid) {
                // 修改栏目
                // 根据 innerid 查找对于栏目
                this.getCwKmcStarcustomcolumninfodetailList(innerid,'update')

                // let tabtada = this.tableData

                // for (let item in tabtada) {
                //     if (tabtada[item].innerid === innerid) {

                //         this.columninnerid = innerid

                //         this.updatestart = this.dialogVisible = true
                //         this.form.linktype = tabtada[item].linktype
                //         this.form.linkurl = tabtada[item].linkurl
                //         this.form.kmctype = tabtada[item].kmctype
                //         this.form.columnname = tabtada[item].columnname
                //         this.form.linkkeyid = tabtada[item].linkkeyid

                //         // 商品分组 获取分组信息
                //         if (this.form.linktype === 4) {
                //             this.setLoading(true)

                //             getAssetGroupInfo({
                //                 data: {innerid: this.form.linkkeyid},
                //                 success: data => {
                //                     this.$nextTick(() => {
                //                         this.setCommoditydata = data.data
                //                         this.setLoading(false)
                //                     })
                //                 },
                //                 error: data => {
                //                     this.$message.error(data.msg)
                //                     this.setLoading(false)
                //                 }
                //             })
                //         }
                //         // 单一商品 获取商品信息
                //         if (this.form.linktype === 3) {
                //             this.setLoading(true)

                //             getProductDetail({
                //                 data: {innerid: this.form.linkkeyid, kmctype: this.form.kmctype},
                //                 success: data => {
                //                     this.$nextTick(() => {
                //                         this.shopDetails = data.data
                //                         this.setLoading(false)
                //                     })
                //                 },
                //                 error: data => {
                //                     this.$message.error(data.msg)
                //                     this.setLoading(false)
                //                 }
                //             })
                //         }

                //     }
                // }

            },
            delcolumn(innerid) {
                // 删除
                this.$confirm('您确定要删除栏目吗?<br/>如果删除栏目，则栏目下的 帖子/资料 将无法正常显示。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let data = {
                        innerid: innerid
                    }
                    this.setLoading(true)
                    deleteCwKmcStarcustomcolumninfo({
                        data: data,
                        success: data => {
                            this.setLoading(false)
                            this.$message.success('删除成功')
                            this.tableList()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })

                }).catch(() => {});
            },
            paixu(innerid) {
                // 排序
                this.$prompt('请输入序号', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {

                    if (value === '') {
                        this.$message.error('序号不能为空')
                    } else {
                        let data = {
                            innerid: innerid,
                            columnindex: value
                        }
                        this.setLoading(true)
                        updateCwKmcStarcustomcolumninfoIndex({
                            data: data,
                            success: data => {
                                this.setLoading(false)
                                this.$message.success('更改序号成功')
                                this.tableList()
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$message.error(data.msg)
                            }
                        })
                        console.log(value);
                    }

                }).catch(() => {});

            },
            ...mapActions(['setLoading'])
        },
        mounted(){
            this.tableList()
        },
        computed: {
            ...mapGetters(['loading'])
        },
        components: {
            // AddGoodsTips,
            Commodity,
            ShopGroup
        }


    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .Column {
        i.el-icon-error {
            float: right;
            margin-top: 10px;
        }
        .el-table {
            .table-position {
                p {
                    cursor: pointer;
                }
                p,
                span {
                    display: inline-block;
                    padding-left: 7px;
                    font-size: 14px;
                    color: #409eff;
                }
            }
        }
        .el-input__icon {
            line-height: normal;
        }
        .dataform {
            display: block;
            margin: auto;
            width: 437px;
            p {
                font-size: 14px;
                color: #909399;
            }
            .title {
                display: inline-block;
                width: 363px;
                overflow: hidden;
                text-overflow: ellipsis;
                word-spacing: normal;
                white-space: nowrap;
            }
            .block {
                padding: 10px;
                box-sizing: border-box;
                background: #F5F7FA;

                .card {
                    .name {
                        color: #303133;
                    }
                }
                .tw {
                    .img {
                        display: inline-block;
                        position: relative;
                        width: 40px;
                        // height: 60px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                        .tag {
                            position: absolute;
                            right: 0;
                            bottom: 12px;
                            width: 36px;
                            height: 17px;
                            color: #fff;
                            font-size: 12px;
                            line-height: 17px;
                            text-align: center;
                            background: #909399;
                        }
                    }
                    .title {
                         margin-left: 10px;
                        width: 271px;
                    }
                }
            }
            .fz {

            }
        }
    }

</style>
